import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { changeCardMakeSettlementStatus, changeCardMakeStatus, changeCardMakeUpStatus, exportFileCardMake, getCardMakeList, getCardMakeSupplierList, getMakeCardCityList } from '@/views/salesCardManagement/api';
import PrintingUploadDialog from '@/views/salesCardManagement/printingUploadDialog';
import SendSupplierDialog from '@/views/manageCenter/components/sendSupplierDialog';
import CreatePrintingRecord from '@/views/salesCardManagement/createPrintingRecord.vue';
import AddCardDialog from './AddCardDialog.vue';
import { getCustomerCompanyName } from '@/views/cardSystem/customer/api';
import { searchUserList } from '../../api';
import applyForm from '@/views/cardSystem/saleToos/projectDelivery/applyForm.vue';
export default {
  name: 'PrintWorkOrder',
  components: {
    SendSupplierDialog: SendSupplierDialog,
    PrintingUploadDialog: PrintingUploadDialog,
    CreatePrintingRecord: CreatePrintingRecord,
    AddCardDialog: AddCardDialog,
    applyForm: applyForm
  },
  data: function data() {
    return {
      fileName: {},
      // 侧滑打开【创建印刷单】
      printingRecordDrawer: {
        visible: false,
        params: {}
      },
      dataList: [],
      pages: {},
      supplierList: [],
      dialogStatusVisible: false,
      printingUploadDialog: false,
      dialogExportVisible: false,
      has_wx_account: '1',
      yl88: [],
      sumInfo: {},
      cityOptions: [],
      // 人员下拉远程搜索：按下拉字段隔离选项，已选项缓存记录 id→选项（换关键字后已选标签不退化）
      personOptions: {},
      personOptionCache: {},
      personLoading: false,
      form: {
        print_type: '',
        // 印刷类型
        material_type: '',
        // 物料类型
        supplier_id: '',
        // 供应商
        make_status: '0',
        // 制作状态
        settlement_status: '',
        // 结算状态
        city: [],
        status: '1',
        id: '',
        // 记录单ID
        batch: '',
        // 卡批次号
        customer_id: '',
        // 客户id
        order_id: '',
        // 订单id
        user_id: '',
        // 销售
        is_urgent: '',
        // 是否加急 1:是 0:否
        start_num: '',
        // 起始数量
        end_num: '',
        // 结束数量
        project_delivery_number: '',
        // 设计工单ID
        card_make_status: [],
        // 制作状态
        create_time: [],
        page: 1
      },
      statusType: '',
      ruleForm: {
        make_status: '',
        // 制作状态
        settlement_status: '',
        // 结算状态
        status: '' // 有效无效状态
      },
      row: {},
      applyFormVisible: false,
      applyFormType: 'view',
      selectedId: null,
      selectedProjectType: null,
      selectedProjectStatus: null,
      drawerTitle: '装修&项目交付申请',
      normalizedFromTab: '2'
    };
  },
  computed: {
    companyList: function companyList() {
      return this.$store.state.user.companyList;
    }
  },
  created: function created() {
    this.getSupplier();
    this.getCity();
    this.getList();
    // 初始预载人员下拉默认选项（空关键词返回默认列表）
    this.searchSellUser('');
  },
  methods: {
    getCity: function getCity() {
      var _this = this;
      getMakeCardCityList().then(function (res) {
        _this.cityOptions = res.data;
      });
    },
    // 获取第一张优先显示的图片（优先 jpg/jpeg/png）
    getFirstImage: function getFirstImage(designImgList) {
      if (!designImgList || designImgList.length === 0) return null;
      // 优先查找 jpg/jpeg/png 格式的图片
      var priorityExtensions = ['jpg', 'jpeg', 'png'];
      var _loop = function _loop() {
          var ext = _priorityExtensions[_i];
          var found = designImgList.find(function (img) {
            var fileExtension = img.split('.').pop().toLowerCase();
            return fileExtension === ext;
          });
          if (found) return {
            v: found
          };
        },
        _ret;
      for (var _i = 0, _priorityExtensions = priorityExtensions; _i < _priorityExtensions.length; _i++) {
        _ret = _loop();
        if (_ret) return _ret.v;
      }
      // 如果没有找到优先格式，返回第一张图片（只要是图片格式）
      var imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
      var firstImage = designImgList.find(function (img) {
        var fileExtension = img.split('.').pop().toLowerCase();
        return imageExtensions.includes(fileExtension);
      });
      return firstImage || null;
    },
    // 判断是否为图片
    isImage: function isImage(filePath) {
      var imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
      var fileExtension = filePath.split('.').pop().toLowerCase();
      return imageExtensions.includes(fileExtension);
    },
    // 判断是否为PDF
    isPDF: function isPDF(filePath) {
      var fileExtension = filePath.split('.').pop().toLowerCase();
      return fileExtension === 'pdf';
    },
    // 判断是否为AI
    isAI: function isAI(filePath) {
      var fileExtension = filePath.split('.').pop().toLowerCase();
      return fileExtension === 'ai';
    },
    // 获取图片列表（过滤掉非图片格式的文件）
    getImageList: function getImageList(designImgList) {
      if (!designImgList || designImgList.length === 0) return [];
      var imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
      return designImgList.filter(function (img) {
        var fileExtension = img.split('.').pop().toLowerCase();
        return imageExtensions.includes(fileExtension);
      });
    },
    // 获取供应商
    getSupplier: function getSupplier() {
      var _this2 = this;
      getCardMakeSupplierList().then(function (res) {
        _this2.supplierList = res.data;
      });
    },
    // 获取列表：项目交付入口固定携带 is_project_delivery = 1
    getList: function getList() {
      var _this3 = this;
      var params = _objectSpread(_objectSpread({}, this.form), {}, {
        is_project_delivery: 1
      });
      getCardMakeList(params).then(function (res) {
        _this3.dataList = res.data.list;
        _this3.sumInfo = res.data.total;
        _this3.pages = res.pages;
      });
    },
    // 列表搜索条件联动“印刷工单”角标：仅在筛选条件变化时上报当前搜索参数，
    // 由父级转发至 all-to-do 计数的 card_make_print 参数，保持角标与列表口径一致。
    // 不在 getList 中调用，避免翻页/无关刷新时重复拉取计数
    emitCountChange: function emitCountChange() {
      this.$emit('searchCountChange', _objectSpread(_objectSpread({}, this.form), {}, {
        is_project_delivery: 1
      }));
    },
    remoteMethod: function remoteMethod(val) {
      this.$store.dispatch('user/getCompanyList', {
        val: val
      });
    },
    // 侧滑打开【创建印刷单】
    openPrintingRecordDrawer: function openPrintingRecordDrawer(params, type) {
      this.printingRecordDrawer.params = {
        id: params.id,
        batch: params.batch,
        type: type,
        project_id: params.project_id || '',
        form: 'printing',
        is_make_card: params.id && params.batch ? '1' : '0',
        is_getApi: type === 'edit' || params.batch ? '1' : '2' // 1的时候调用info接口
      };
      this.printingRecordDrawer.visible = true;
    },
    // 供应商发邮件
    sendSupplier: function sendSupplier(row) {
      if (!row.email) {
        this.$message.error('请先设置印刷供应商的手机号和邮箱再发送');
        return false;
      }
      this.yl88 = [];
      this.dialogExportVisible = true;
      this.row = row;
    },
    confirmExport: function confirmExport() {
      var event = this.$refs.sendSupplierDialog;
      event.sendSupplierDialog = true;
      event.id = this.row.id;
      event.has_wx_account = this.has_wx_account;
      event.yl88 = this.yl88;
      event.getCardMakeInfo();
      this.dialogExportVisible = false;
    },
    viewAllCompany: function viewAllCompany(row) {
      getCustomerCompanyName({
        id: row.customer_id
      }).then(function (res) {
        row.customer_name = res.data.company_name;
      });
    },
    sendSuccess: function sendSuccess() {
      this.getList();
    },
    // 印刷单保存成功后：关闭侧滑 + 刷新列表
    handlePrintingRecordSuccess: function handlePrintingRecordSuccess() {
      this.printingRecordDrawer.visible = false;
      this.getList();
    },
    // 添加制卡（复制自 allToDo.vue）：打开 AddCardDialog
    // type='view' 为基本信息点击批次号的查看模式；其余（如操作列「添加制卡」）走原有逻辑
    handleAddCard: function handleAddCard(row, type) {
      var event = this.$refs.addCardDialog;
      event.open(row, type);
    },
    // 制卡成功：刷新列表
    handleAddCardSuccess: function handleAddCardSuccess() {
      this.getList();
    },
    // 导出
    exportPrinting: function exportPrinting() {
      var _this4 = this;
      var params = this.form;
      params.is_project_delivery = 1;
      exportFileCardMake(params).then(function (res) {
        _this4.$message.success('开始生成文件，请在【下载中心】查看进度并下载文件到本地');
      });
    },
    // 修改状态
    changeStatus: function changeStatus(row, type) {
      this.row = row;
      this.statusType = type;
      this.dialogStatusVisible = true;
      this.statusType === 'make_status' && (this.ruleForm.make_status = row.make_status);
      this.statusType === 'settlement_status' && (this.ruleForm.settlement_status = row.settlement_status);
      this.statusType === 'status' && (this.ruleForm.status = row.status);
    },
    // 确定状态
    submitStatus: function submitStatus() {
      var _this5 = this;
      var params = this.ruleForm;
      params.id = this.row.id;
      if (this.statusType === 'make_status') {
        changeCardMakeStatus(params).then(function (res) {
          _this5.$message.success('修改成功');
          _this5.dialogStatusVisible = false;
          _this5.getList();
          return false;
        });
      }
      if (this.statusType === 'settlement_status') {
        changeCardMakeSettlementStatus(params).then(function (res) {
          _this5.$message.success('修改成功');
          _this5.dialogStatusVisible = false;
          _this5.getList();
          return false;
        });
      }
      if (this.statusType === 'status') {
        changeCardMakeUpStatus(params).then(function (res) {
          _this5.$message.success('修改成功');
          _this5.dialogStatusVisible = false;
          _this5.getList();
        });
      }
    },
    viewProjectDetail: function viewProjectDetail(row) {
      var info = row;
      this.selectedId = info.project_delivery_id;
      this.selectedProjectType = info.project_type;
      this.selectedProjectStatus = info.status;
      this.applyFormType = 'view';
      this.drawerTitle = '装修&项目交付申请（任务ID：' + info.project_delivery_number + '）';
      this.applyFormVisible = true;
    },
    // 打开订单列表
    goOrderList: function goOrderList(item) {
      var src = '';
      src = "".concat(this.$store.state.user.domainName, "/#/order/orderList?order_id=").concat(item, "&search=no");
      window.open(src, '_blank');
    },
    // 上传文件
    uploadFile: function uploadFile(row) {
      var event = this.$refs.printingUploadDialog;
      event.printingUploadDialog = true;
      event.ruleForm.id = row.id;
      event.formType = 'printing';
      // 确保row.design_img存在且是数组
      if (row.design_img && Array.isArray(row.design_img) && row.design_img.length > 0) {
        event.ruleForm.file = _toConsumableArray(row.design_img);
      }
    },
    handleExportClose: function handleExportClose() {
      this.yl88 = [];
      this.dialogExportVisible = false;
    },
    emitGet: function emitGet() {
      this.getList();
    },
    // 检索
    search: function search() {
      this.form.page = 1;
      this.getList();
      this.emitCountChange();
    },
    // 重置
    clearForm: function clearForm() {
      this.$refs.form.resetFields();
      this.getList();
      this.emitCountChange();
    },
    // 人员下拉通用远程搜索：结果按字段存进 personOptions，已选项从缓存回填
    searchPerson: function searchPerson(keyword, field, valueGetter) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var kw, res, list, selected, picked;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              kw = (keyword || '').trim();
              _this6.personLoading = true;
              _context.p = 1;
              _context.n = 2;
              return searchUserList({
                keyword: kw
              });
            case 2:
              res = _context.v;
              list = res.data || [];
              list.forEach(function (item) {
                _this6.personOptionCache[String(item.id)] = item;
              });
              // 结果并入已选项：换关键字会销毁旧 option，已选标签需继续有数据可查
              selected = valueGetter();
              if (!Array.isArray(selected)) {
                selected = selected === undefined || selected === null || selected === '' ? [] : [selected];
              }
              picked = selected.filter(function (id) {
                return !list.some(function (item) {
                  return String(item.id) === String(id);
                });
              }).map(function (id) {
                return _this6.personOptionCache[String(id)];
              }).filter(Boolean);
              _this6.$set(_this6.personOptions, field, picked.concat(list));
            case 3:
              _context.p = 3;
              _this6.personLoading = false;
              return _context.f(3);
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[1,, 3, 4]]);
      }))();
    },
    // 销售负责人（印刷工单筛选）
    searchSellUser: function searchSellUser(keyword) {
      var _this7 = this;
      return this.searchPerson(keyword, 'sellUser', function () {
        return _this7.form.user_id;
      });
    },
    // 分页
    currentChange: function currentChange(val) {
      this.form.page = val;
      this.getList();
    }
  }
};